const agenda = {
  NAME: 'agenda',
  SET: 'SET_AGENDA',
  SET_ACCORDION: 'SET_ACCORDION'
}

export default {
  agenda: agenda
}